module.exports = __webpack_public_path__ + "static/media/rikki_roll.b5746dd4.webp";